import { render, staticRenderFns } from "./AiChatContentCard.vue?vue&type=template&id=1d22b8b0&scoped=true&"
import script from "./AiChatContentCard.vue?vue&type=script&lang=js&"
export * from "./AiChatContentCard.vue?vue&type=script&lang=js&"
import style0 from "./AiChatContentCard.vue?vue&type=style&index=0&id=1d22b8b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d22b8b0",
  null
  
)

export default component.exports